/**
 * TradingPausedBanner — red banner shown on all pages when trading is stopped.
 */

import React from 'react';
import { ShieldOff, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface TradingPausedBannerProps {
  visible: boolean;
}

const TradingPausedBanner: React.FC<TradingPausedBannerProps> = ({ visible }) => {
  const navigate = useNavigate();

  if (!visible) return null;

  return (
    <div className="bg-red-600 text-white px-4 py-2.5 flex items-center justify-center gap-2 text-sm font-medium shadow-sm">
      <ShieldOff className="w-4 h-4 flex-shrink-0" />
      <span>Trading is <strong>PAUSED</strong> — No automated orders will be placed.</span>
      <button
        onClick={() => navigate('/schedule?view=positions')}
        className="inline-flex items-center gap-1 ml-2 px-2.5 py-1 bg-white/20 hover:bg-white/30 rounded text-xs font-semibold transition-colors"
      >
        Manage Positions
        <ArrowRight className="w-3 h-3" />
      </button>
    </div>
  );
};

export default TradingPausedBanner;
